/*
 * Product page behaviour for the ported WP/WooCommerce templates.
 * Replaces the WP inline scripts + main.js order-summary code:
 *  - [data-cs-kit]     Build Your Kit (instructor kits, train-the-trainer) + attendee e-mail popup
 *  - [data-cs-online]  online course pricing calculator (#priceform)
 *  - [data-cs-book]    response book / patch purchase block
 *  - [data-cs-media]   WooCommerce default product layout (qty buttons, thumbnails, tabs)
 *  - [data-cs-related] optional Shopify product recommendations
 * Tier prices are DISPLAY ONLY; the real discount must come from Shopify discounts.
 * Cart writes go through window.CSCart (assets/cs-cart.js); successful adds redirect to the cart.
 */
(function () {
  'use strict';
  if (window.CSProduct) return;
  window.CSProduct = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function readJSON(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function formatPrice(dollars) {
    return '$' + Number(dollars || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function cartUrl() {
    return (window.CS && window.CS.routes && window.CS.routes.cart) || '/cart';
  }

  /** Unit price (dollars) for a quantity from [{min,max,price}] tiers, or null when no tier applies. */
  function tierPrice(tiers, qty) {
    if (!tiers || !tiers.length || !qty) return null;
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      if (qty >= Number(t.min) && qty <= Number(t.max)) return Number(t.price);
    }
    var last = tiers[tiers.length - 1];
    if (qty > Number(last.max)) return Number(last.price);
    return null;
  }

  /** Mark the .bulk-tier matching qty as active inside a container. */
  function markTiers(container, tiers, qty) {
    if (!container || !tiers || !tiers.length) return;
    var spans = container.querySelectorAll('.bulk-tier');
    var activeIndex = -1;
    if (qty > 0) {
      for (var i = 0; i < tiers.length; i++) {
        if (qty >= Number(tiers[i].min) && qty <= Number(tiers[i].max)) { activeIndex = i; break; }
      }
      if (activeIndex === -1 && qty > Number(tiers[tiers.length - 1].max)) activeIndex = tiers.length - 1;
    }
    spans.forEach(function (s, i) { s.classList.toggle('active', i === activeIndex); });
  }

  function showMessage(root, message, type) {
    var box = root.querySelector('[data-cs-messages]');
    if (!box) { if (message) window.alert(message); return; }
    box.innerHTML = '';
    if (!message) return;
    var div = document.createElement('div');
    div.className = 'cs-notice cs-notice--' + (type || 'error');
    div.setAttribute('role', type === 'success' ? 'status' : 'alert');
    div.textContent = message;
    box.appendChild(div);
  }

  function setBusy(button, busy, busyLabel) {
    if (!button) return;
    var label = button.querySelector('[data-cs-btn-label]') || button;
    if (busy) {
      button.dataset.csLabel = label.textContent;
      label.textContent = busyLabel || 'Adding...';
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    } else {
      if (button.dataset.csLabel) label.textContent = button.dataset.csLabel;
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  }

  function addAndRedirect(root, button, items, busyLabel) {
    if (!window.CSCart) { showMessage(root, 'Cart is unavailable. Please reload the page.'); return; }
    showMessage(root, '');
    setBusy(button, true, busyLabel);
    window.CSCart.add(items)
      .then(function () { window.location.href = cartUrl(); })
      .catch(function (err) {
        setBusy(button, false);
        showMessage(root, (err && err.message) || 'Could not add to cart. Please try again.');
      });
  }

  /** Delegated +/- handling for `.qty-btn.plus/.minus` next to `input.qty` inside root. */
  function bindQtyButtons(root, minFor, onChange) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.qty-btn');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      var wrap = btn.parentElement;
      var input = wrap && wrap.querySelector('input.qty');
      if (!input) return;
      var min = minFor(input);
      var val = parseInt(input.value, 10) || 0;
      val = btn.classList.contains('plus') ? val + 1 : Math.max(min, val - 1);
      input.value = val;
      onChange(input);
    });
  }

  /* ---------------------------------------------------------------- popups */
  function openPopup(popup) {
    if (!popup) return;
    popup.classList.add('active');
    popup.style.display = 'flex';
    var focusable = popup.querySelector('input, select, iframe, button');
    if (focusable) focusable.focus();
  }
  function closePopup(popup) {
    if (!popup) return;
    popup.classList.remove('active');
    popup.style.display = 'none';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cs-open-popup]');
    if (opener) {
      e.preventDefault();
      openPopup(document.getElementById(opener.getAttribute('data-cs-open-popup')));
      return;
    }
    var closer = e.target.closest('[data-cs-close-popup]');
    if (closer) {
      e.preventDefault();
      closePopup(closer.closest('[data-cs-popup]'));
      return;
    }
    if (e.target.matches && e.target.matches('[data-cs-popup]')) closePopup(e.target);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-cs-popup].active').forEach(closePopup);
  });

  /* ------------------------------------------------------- build your kit */
  function initKit(root) {
    var data = readJSON(root, '[data-cs-kit-data]');
    if (!data) return;
    var kitQtyInput = root.querySelector('#kit-quantity');
    var rbQtyInput = root.querySelector('#response-books-qty');
    var popupBtn = root.querySelector('#openPopupBtn');
    var addBtn = root.querySelector('#add-to-cart-btn');
    var linesEl = root.querySelector('#order-line-items');
    var totalEl = root.querySelector('#order-total');
    var rbStep = root.querySelector('.kit-step[data-step="3"]');
    var popup = document.getElementById('popup_attandee');
    var rowTpl = document.getElementById('cs-attendee-row');
    var otherAttendees = popup && popup.querySelector('#other_attendee');
    var dateSelect = root.querySelector('#workshop');
    var radios = root.querySelectorAll('input[name="kit[]"]');

    function kitQty() { return Math.max(1, parseInt(kitQtyInput && kitQtyInput.value, 10) || 1); }
    function rbQty() { return Math.max(0, parseInt(rbQtyInput && rbQtyInput.value, 10) || 0); }
    function setKitQty(q) { if (kitQtyInput) { kitQtyInput.value = Math.max(1, q); update(); } }

    function selectedVariant() {
      if (data.simple) return data.kitVariants[0] || null;
      var checked = root.querySelector('input[name="kit[]"]:checked');
      if (!checked) return null;
      var vid = Number(checked.getAttribute('data-vid'));
      for (var i = 0; i < data.kitVariants.length; i++) {
        if (data.kitVariants[i].id === vid) return data.kitVariants[i];
      }
      return null;
    }

    function isStreaming() {
      var v = selectedVariant();
      return !!(v && !data.simple && v.value === 'streaming');
    }

    function capitalize(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

    function lineHtml(label, amount) {
      return '<div class="order-line"><span class="order-item"></span><span class="order-price">' + formatPrice(amount) + '</span></div>';
    }

    function update() {
      var q = kitQty();
      var total = 0;
      var lines = [];
      var v = selectedVariant();
      if (v && data.hasKit) {
        var unit = tierPrice(data.kitTiers, q);
        if (unit === null) unit = v.price / 100;
        var label = q + ' × ' + data.kitLineLabel + (data.simple ? '' : ' (' + capitalize(v.value) + ')');
        lines.push([label, unit * q]);
        total += unit * q;
      }
      var rq = rbQty();
      if (data.rb && rq > 0) {
        var rbUnit = tierPrice(data.rb.tiers, rq);
        if (rbUnit === null) rbUnit = data.rb.price / 100;
        lines.push([rq + ' × ' + data.rbLineLabel, rbUnit * rq]);
        total += rbUnit * rq;
        var rbPrice = rbStep && rbStep.querySelector('.step-header .price span');
        if (rbPrice) rbPrice.textContent = formatPrice(rbUnit);
      }
      if (!lines.length) lines.push([data.emptyLabel, 0]);

      if (linesEl) {
        linesEl.innerHTML = '';
        lines.forEach(function (l) {
          var wrap = document.createElement('div');
          wrap.innerHTML = lineHtml(l[0], l[1]);
          var row = wrap.firstChild;
          row.querySelector('.order-item').textContent = l[0];
          linesEl.appendChild(row);
        });
      }
      if (totalEl) totalEl.textContent = formatPrice(total);

      var visibleTiers = data.simple
        ? root.querySelector('.kit-step[data-step="1"] .bulk-tiers')
        : (v ? root.querySelector('#teir-' + v.id) : null);
      markTiers(visibleTiers, data.kitTiers, q);
      if (rbStep && data.rb) markTiers(rbStep.querySelector('.bulk-tiers'), data.rb.tiers, rq);
    }

    function onVariantChange() {
      var v = selectedVariant();
      root.querySelectorAll('.contact-note > .bulk-tiers[id^="teir-"]').forEach(function (el) {
        el.style.display = v && el.id === 'teir-' + v.id ? '' : 'none';
      });
      if (popupBtn && !data.simple) popupBtn.style.display = isStreaming() ? 'table' : 'none';
      update();
    }

    radios.forEach(function (r) { r.addEventListener('change', onVariantChange); });

    // WP pre-selects "streaming"; fall back to the first available format.
    if (radios.length && !root.querySelector('input[name="kit[]"]:checked')) {
      var preferred = root.querySelector('input[name="kit[]"][value="streaming"]:not([disabled])') ||
        root.querySelector('input[name="kit[]"]:not([disabled])');
      if (preferred) preferred.checked = true;
    }
    onVariantChange();

    bindQtyButtons(root, function (input) { return input === rbQtyInput ? 0 : 1; }, function () {
      showMessage(root, '');
      update();
    });

    /* attendee e-mails: the kit quantity follows the attendee count */
    function emailInputs() { return popup ? popup.querySelectorAll('input.attendee-email') : []; }
    if (popup) {
      popup.addEventListener('click', function (e) {
        if (e.target.closest('.add-email-btn')) {
          e.preventDefault();
          if (!rowTpl || !otherAttendees) return;
          otherAttendees.appendChild(rowTpl.content.cloneNode(true));
          var inputs = emailInputs();
          if (inputs.length > kitQty()) setKitQty(inputs.length);
          inputs[inputs.length - 1].focus();
        } else if (e.target.closest('.remove-email-btn')) {
          e.preventDefault();
          var row = e.target.closest('.attendee-emails');
          if (row) row.remove();
          var count = emailInputs().length;
          if (kitQty() > count) setKitQty(kitQty() - 1);
        }
      });
      popup.addEventListener('input', function (e) {
        if (e.target.classList && e.target.classList.contains('attendee-email')) e.target.classList.remove('cs-invalid');
      });
    }

    function collectEmails() {
      var list = [];
      emailInputs().forEach(function (i) { if (i.value.trim()) list.push(i.value.trim()); });
      return list;
    }

    function emailsValid() {
      var inputs = emailInputs();
      if (!inputs.length) return false;
      var ok = true;
      inputs.forEach(function (i) {
        var bad = !EMAIL_RE.test(i.value.trim());
        i.classList.toggle('cs-invalid', bad);
        if (bad) ok = false;
      });
      return ok;
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var v = selectedVariant();
        if (data.hasKit && !data.simple && !v) { showMessage(root, data.errors.kit); return; }
        var date = dateSelect ? dateSelect.value : '';
        if (data.ttt && dateSelect && !date) { showMessage(root, data.errors.date); dateSelect.focus(); return; }
        if (isStreaming() && !emailsValid()) {
          showMessage(root, data.errors.emails);
          openPopup(popup);
          return;
        }
        var emails = collectEmails().join(', ');
        var items = [];
        if (data.ttt && data.registrationVariantId) {
          var regProps = {};
          if (date) regProps['Workshop date'] = date;
          if (emails) regProps['Attendee emails'] = emails;
          items.push({ id: data.registrationVariantId, quantity: 1, properties: regProps });
        }
        if (v && data.hasKit) {
          var kitItem = { id: v.id, quantity: kitQty() };
          if (!data.ttt && emails) kitItem.properties = { 'Attendee emails': emails };
          items.push(kitItem);
        }
        if (data.rb && rbQty() > 0) items.push({ id: data.rb.id, quantity: rbQty() });
        if (!items.length) { showMessage(root, data.errors.kit); return; }
        addAndRedirect(root, addBtn, items, data.addingLabel);
      });
    }
  }

  /* ---------------------------------------------------- online calculator */
  function initOnline(root) {
    var data = readJSON(root, '[data-cs-online-data]');
    if (!data) return;
    var form = root.querySelector('#custom-add-to-cart-form');
    var qtyInput = root.querySelector('#kit-quantity');
    var priceEl = root.querySelector('#oprice');
    var base = data.price / 100;

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function update() {
      var q = qty();
      var unit = tierPrice(data.tiers, q);
      if (unit === null) unit = base;
      if (!priceEl) return;
      if (unit.toFixed(2) === base.toFixed(2)) {
        priceEl.textContent = formatPrice(unit * q);
      } else {
        priceEl.innerHTML = '';
        priceEl.appendChild(document.createTextNode(formatPrice(unit * q) + ' '));
        var del = document.createElement('del');
        del.textContent = formatPrice(base * q);
        priceEl.appendChild(del);
      }
    }
    bindQtyButtons(root, function () { return 1; }, function () { showMessage(root, ''); update(); });
    update();

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addAndRedirect(root, form.querySelector('.custom-add-to-cart'), [{ id: data.variantId, quantity: qty() }], data.addingLabel);
      });
    }
  }

  /* ---------------------------------------------------- response book page */
  function initBook(root) {
    var data = readJSON(root, '[data-cs-book-data]');
    if (!data) return;
    var qtyInput = root.querySelector('#response-books-qty');
    var priceEl = root.querySelector('.product-price .price-amount');
    var addBtn = root.querySelector('[data-cs-add]');
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function update() {
      var q = qty();
      var unit = tierPrice(data.tiers, q);
      if (unit !== null && priceEl) priceEl.textContent = formatPrice(unit);
      else if (priceEl && data.tiers.length) priceEl.textContent = formatPrice(data.price / 100);
      markTiers(root.querySelector('.bulk-tiers'), data.tiers, q);
    }
    bindQtyButtons(root, function () { return 1; }, function () { showMessage(root, ''); update(); });
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addAndRedirect(root, addBtn, [{ id: data.variantId, quantity: qty() }], data.addingLabel);
      });
    }
  }

  /* -------------------------------------------- WooCommerce default layout */
  function initMedia(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.minuss, .pluss');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        var input = btn.parentElement.querySelector('input.qty');
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        input.value = btn.classList.contains('pluss') ? val + 1 : Math.max(1, val - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var thumb = e.target.closest('[data-cs-thumb]');
      if (thumb) {
        var main = root.querySelector('[data-cs-main-image] img');
        if (main) { main.src = thumb.getAttribute('data-cs-thumb'); main.removeAttribute('srcset'); }
        root.querySelectorAll('[data-cs-thumb]').forEach(function (t) { t.classList.toggle('flex-active', t === thumb); });
        return;
      }
      var tab = e.target.closest('[data-cs-tab]');
      if (tab) {
        e.preventDefault();
        var target = tab.getAttribute('href');
        root.querySelectorAll('.wc-tabs li').forEach(function (li) { li.classList.toggle('active', li.contains(tab)); });
        root.querySelectorAll('.woocommerce-Tabs-panel').forEach(function (p) { p.hidden = '#' + p.id !== target; });
      }
    });
  }

  /* --------------------------------------------- product recommendations */
  function initRelated(root) {
    var url = root.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cs-related]');
        if (fresh && fresh.querySelector('.related-product-card')) root.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-cs-kit]').forEach(initKit);
    document.querySelectorAll('[data-cs-online]').forEach(initOnline);
    document.querySelectorAll('[data-cs-book]').forEach(initBook);
    document.querySelectorAll('[data-cs-media]').forEach(initMedia);
    document.querySelectorAll('[data-cs-related][data-url]').forEach(initRelated);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
